module.exports = __webpack_public_path__ + "img/betmode_result_nfl.1f7f44b4.png";